"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Typography;

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _react = _interopRequireDefault(require("react"));

var _makeStyles2 = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _StyledUtils = require("./utils/StyledUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Typography(_ref) {
  var children = _ref.children,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      lineHeight = _ref.lineHeight,
      maxHeight = _ref.maxHeight,
      maxWidth = _ref.maxWidth,
      mr = _ref.mr,
      mx = _ref.mx,
      my = _ref.my,
      overflow = _ref.overflow,
      p = _ref.p,
      pb = _ref.pb,
      pt = _ref.pt,
      whiteSpace = _ref.whiteSpace,
      wordBreak = _ref.wordBreak,
      wordWrap = _ref.wordWrap,
      props = _objectWithoutProperties(_ref, ["children", "fontSize", "fontWeight", "lineHeight", "maxHeight", "maxWidth", "mr", "mx", "my", "overflow", "p", "pb", "pt", "whiteSpace", "wordBreak", "wordWrap"]);

  var _makeStyles = (0, _makeStyles2["default"])(function () {
    return {
      style: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, fontSize), fontWeight), lineHeight), (0, _StyledUtils.scaleFactorProp)({
        marginRight: mr
      })), (0, _StyledUtils.scaleFactorProp)({
        marginLeft: mx
      })), (0, _StyledUtils.scaleFactorProp)({
        marginRight: mx
      })), (0, _StyledUtils.scaleFactorProp)({
        marginBottom: my
      })), (0, _StyledUtils.scaleFactorProp)({
        marginTop: my
      })), maxHeight), maxWidth), overflow), (0, _StyledUtils.scaleFactorProp)({
        padding: p
      })), (0, _StyledUtils.scaleFactorProp)({
        paddingBottom: pb
      })), (0, _StyledUtils.scaleFactorProp)({
        paddingTop: pt
      })), (0, _StyledUtils.scaleFactorProp)({
        whiteSpace: whiteSpace
      })), (0, _StyledUtils.scaleFactorProp)({
        wordBreak: wordBreak
      })), (0, _StyledUtils.scaleFactorProp)({
        wordWrap: wordWrap
      }))
    };
  })(),
      style = _makeStyles.style;

  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    _react["default"].createElement(_Typography2["default"], _extends({}, props, {
      className: style
    }), children)
  );
}